<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Create Director</h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input id="title" v-model="entity.title" type="text" placeholder="Enter title" class="form-control">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <ckeditor id="description" v-model="entity.description" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Thumbnail</label>
                  <div class="col-md-10">
                    <image-uploader @changeFile="avatarUploaded" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="email" class="col-md-2">Email *</label>
                  <div class="col-md-10">
                    <input id="email" v-model="entity.email" type="email" placeholder="Enter email" class="form-control">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input id="seo_title" v-model="entity.seo_title" type="text" placeholder="Enter SEO title" class="form-control">
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Director has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';

export default {
  name: 'DirectorsNew',

  mixins: [CreatePageMixin],

  data() {
    return {
      entity: {
        title: null,
        description: null,
        avatar: null,
        seo_title: '',
        seo_description: '',
        email: '',
      },
    };
  },

  methods: {
    isEntityValid() {
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      return true;
    },
    isEmailEntityValid() {
      if (!this.entity.email) {
        this.$_showError('Email field is required');
        return false;
      }
      return true;
    },
    avatarUploaded(file) {
      this.entity.avatar = file;
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('email', this.entity.email);
      if (this.entity.description) postFormData.append('description', this.entity.description);
      if (this.entity.avatar) postFormData.append('avatar', this.entity.avatar);
      postFormData.append('seo_title', this.entity.seo_title);
      postFormData.append('seo_description', this.entity.seo_description);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}directors`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (!this.isEmailEntityValid()) return;
      this.saveRequest()
        .then((response) => {
          this.$_successSave();
          this.$parent.getSource();
          window.location.hash = `#/admin/directors/edit/${response.data.id}`;
        }).catch((error) => {
          console.error('Error in directors create query', error);
          this.$_errorSave(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?589174d3